<template>
<div class="form-group">
    <label
        class="w-100 checkbox px-3 py-2 d-flex justify-content-between border rounded"
        :for="id_computed"
    >
        <div>
            <div class="font-weight-bold">{{ person.name }}</div>
            <div class="text-muted">{{ person.email }}</div>
        </div>

        <div class="my-auto">
            <input
                type="checkbox"
                v-model="selected"
                :id="id_computed"
                @click="toggleSelected"
            >
            <div class="checkbox--check"></div>

        </div>
    </label>
</div>
</template>

<script>
export default {
    name: "FormPeopleItem",
    components: {},
    data() {
        return {
            selected: false
        };
    },
    computed: {
        id_computed() {
            return `${this.person.id}-selected`;
        },
    },
    props: {
        person: {
            type: Object,
            required: true,
        },
    },
    methods: {
        toggleSelected() {
            this.selected = !this.selected;
        },
    },
}
</script>
